export const SUPPORT_CONTACT_URL = 'https://suporte.jusbrasil.com.br/hc/pt-br/requests/new'
export const TERMS_URL =
  'https://suporte.jusbrasil.com.br/hc/pt-br/articles/360041534072-Termos-de-Uso-da-Plataforma-Jusbrasil'
export const PRIVACY_POLICY_URL = 'https://suporte.jusbrasil.com.br/hc/pt-br/articles/360041534212'
